"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDBVersion = exports.Const_UniqueKeys = exports.Const_UniqueKey = void 0;
exports.Const_UniqueKey = '_id';
exports.Const_UniqueKeys = [exports.Const_UniqueKey];
exports.DefaultDBVersion = '1.0.0';
